import React from "react";

const HeaderSkeleton = () => {
  return (
    <header className="header skeleton-header">
      <div className="container">
        <div className="inner-header d-flex align-items-center justify-content-between">

          {/* Logo skeleton */}
          <div className="skeleton-logo shimmer"></div>

          {/* Menu skeleton */}
          <ul className="skeleton-menu d-none d-lg-flex">
            {[1, 2, 3, 4].map((i) => (
              <li key={i} className="skeleton-menu-item shimmer"></li>
            ))}
          </ul>

          {/* Buttons skeleton */}
          <div className="skeleton-header-buttons">
            <div className="skeleton-btn shimmer"></div>
            <div className="skeleton-btn small shimmer"></div>
          </div>

        </div>
      </div>
    </header>
  );
};

export default HeaderSkeleton;
